<template>
  <FormModal :title="headTitle" show-back-btn>
    <template #body>
      <ExecutionPeriodFormStep :progress-value="progressValue" />
    </template>
  </FormModal>
</template>

<script>
// PD-10940: variant-only step.
import FormModal from 'chimera/all/themes/blueflow/components/layout/FormModal'
import AbstractFormPage from 'chimera/all/components/page/AbstractFormPage'
import ExecutionPeriodFormStep from '~/components/form/steps/executionPeriod/ExecutionPeriodFormStep.PD-10940'

export default {
  components: {
    ExecutionPeriodFormStep,
    FormModal,
  },

  extends: AbstractFormPage,

  layout: 'form',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Wanneer wilt u de ramen plaatsen?',
      headDescription: 'Geef aan wanneer u de ramen wilt laten plaatsen.',
      path: '/offertes-aanvragen/wanneer-ramen-plaatsen',
      checkoutStep: 2,
      progressValue: 50,
    }
  },
}
</script>
